import { useEffect } from "react";

export default function ArticleEmbedDatawrapper({ url }: { url: string }) {
  useEffect(() => {
    // code from drupal
    const handler = (event: MessageEvent) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (typeof event.data["datawrapper-height"] !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        for (const chartId in event.data["datawrapper-height"]) {
          console.log(chartId, "window.addEventListener message");
          const iframe =
            document.getElementById("datawrapper-chart-" + chartId) ||
            document.querySelector("iframe[src*='" + chartId + "']");
          if (!iframe) {
            continue;
          }
          iframe.style.height =
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            event.data["datawrapper-height"][chartId] + "px";
        }
      }
    };

    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);

  return (
    <iframe
      title="ArticleEmbedDataWrapper"
      className="w-full" // Tailwind not available in TC
      style={{ width: "100%", border: "none" }}
      height="500"
      src={url}
    />
  );
}
